<template>
    <module-card>
        <p>Your type is:</p>
        <v-img class="mx-auto" :max-width="300" :src="myUnderwearPersonality.image" alt="myUnderwearPersonality.label"></v-img>
        <p class="text-h6">{{ myUnderwearPersonality.label }}</p>
        <p>{{ myUnderwearPersonality.text }}</p>
    </module-card>
</template>

<script>
    export default {
        computed: {
            myUnderwearPersonality() {
                let myUnderwearPersonality = this.$store.get('myUnderwearPersonality');

                if (myUnderwearPersonality >= 10 && myUnderwearPersonality <= 17) {
                    return {
                        label: 'Boxer Briefs',
                        image: require('@/assets/underwearPersonality/undweartypes/underwear_boxers.png'),
                        text: 'You’re all about comfort.  You’re also pretty laidback.  You’re can be flirtatious, just a like guy who sags his pants to show his boxers.'
                    };
                }

                if (myUnderwearPersonality >= 18 && myUnderwearPersonality <= 26) {
                    return {
                        label: 'Tighty-Whiteys',
                        image: require('@/assets/underwearPersonality/undweartypes/underwear_tightywhitey.png'),
                        text: 'You’re as shy as this underwear is tight!  You’re SECURE in who you are, and don’t let what others say about you “stain” your reputation.'
                    };
                }

                if (myUnderwearPersonality >= 27 && myUnderwearPersonality <= 34) {
                    return {
                        label: 'Thong',
                        image: require('@/assets/underwearPersonality/undweartypes/underwear_thong.png'),
                        text: 'You are tremendously outgoing, and like to show off your ASSets whenever possible! You also appear calm and collected, but a sensual leopard-printed animal is lurking just beneath the surface!  Rrraawr.'
                    };
                }

                if (myUnderwearPersonality >= 35 && myUnderwearPersonality <= 41) {
                    return {
                        label: 'Jock-strap',
                        image: require('@/assets/underwearPersonality/undweartypes/underwear_jockstrap.png'),
                        text: 'You’re either a total jock, a poser, or really kinky.  Either way, you’re a really passionate person that throws yourself into whatever you’re working on.'
                    };
                }

                if (myUnderwearPersonality >= 42 && myUnderwearPersonality <= 50) {
                    return {
                        label: 'Commando',
                        image: require('@/assets/underwearPersonality/undweartypes/underwear_commando.png'),
                        text: 'Either you’re lazy and forgot to do the laundry, or you’re very down-to-earth and embrace a NATURAL, FREE way of life.'
                    };
                }

                return {
                    label: null,
                    image: null,
                    text: null
                };
            }
        }
    };
</script>
